import {
  ActionField,
  useFormContext,
  ActionFieldChildProps,
} from '@oscar/form';
import { Request } from '@oscar/request';
import { Button, notification, Space } from '@oscar/theme';
import { Popup } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import { REQUEST_TYPE } from 'common/constants/insulation';
import { useAuth } from 'features/auth';
import { MAP_REQUEST_NAME } from 'features/insulation';
import { correctData } from 'features/insulation/utils';
import { filter, forEach, get, isEmpty, map, set } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  convertMomentToString,
  getServiceByURL,
  validateData,
} from 'views/pages/create-instrulation/utils';
import { RemovalChecklist } from '../RemovalChecklist';
import '../style.scss';
import { watchPreloadData } from '@oscar/form/dist/reducer';
import { Empty } from '@oscar/theme';

const SubmitComp = (props: any) => {
  const { statusRequest, onResetMessageNotice, listPanels } = props;
  const navigate = useNavigate();
  const [auth] = useAuth();
  const [showPopup, setShowPopup] = useState('');
  const [isSubmit, setisSubmit] = useState(true);
  const [formContext] = useFormContext();

  const handleCancelSubmit = () => {
    setShowPopup('');
  };

  const handleSubmitSuccess = (dataResponse: any) => {
    if (dataResponse?.code === 1) {
      if (statusRequest?.id) {
        navigate(
          `/insulation/view/${statusRequest?.id}?type=${get(
            REQUEST_TYPE,
            statusRequest.type || REQUEST_TYPE.INSTATEMENT,
          )}`,
        );
      } else {
        navigate(
          `/insulation/view/${dataResponse?.data?.requestId}?type=${get(
            REQUEST_TYPE,
            statusRequest.type || REQUEST_TYPE.INSTATEMENT,
          )}`,
        );
      }
    }
    onResetMessageNotice(dataResponse);
  };

  const handleSaveDraft = (actionProps: any) => {
    const newData = convertMomentToString(actionProps.field?.getFieldsValue());
    actionProps.submitData({
      ...newData,
      isSaveDraft: true,
      service: getServiceByURL(statusRequest.type),
    });
  };

  const TYPE = {
    POSTPONE: 0,
    SUBMIT: 1,
  };

  const REQUEST_STATUS = {
    DRAFT: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'SaveDraft',
          url: statusRequest?.id
            ? APIS.EDIT_INSULATION_REQUEST
            : APIS.CREATE_INSULATION_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const newData = { ...data };
            delete newData['reason'];
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              newData['ScaffoldDetail'] = newData['listScaffoldDetail'];
              newData['listScaffoldDetail'] = [];
            }

            return {
              ...newData,
              service: getServiceByURL(statusRequest.type),
              isSaveDraft: true,
            };
          },
        },
        title: 'Save Draft',
        checkRole: () => {
          return auth?.checkRole('DRAFT', 'SUBMITTED');
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Submit',
          url: statusRequest?.id
            ? APIS.EDIT_INSULATION_REQUEST
            : APIS.CREATE_INSULATION_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const remarks = data.reason;
            delete data['reason'];
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              data['ScaffoldDetail'] = data['listScaffoldDetail'];
              data['listScaffoldDetail'] = [];
            }
            return {
              ...data,
              isSaveDraft: false,
              remarks,
              service: getServiceByURL(statusRequest.type),
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        permission: ['DRAFT', 'SUBMITTED'],
        popUp: true,
      },
    ],
    PENDING_VALIDTION: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Reject',
          url: APIS.REJECT_INSULATION_DETAIL,
          method: 'POST',
          transformRequest: (data: any) => {
            const remarks = data.reason;
            return {
              id: data.id,
              remarks,
            };
          },
        },
        title: 'Reject',
        remarksRequired: true,
        checkRole: () => {
          return auth?.checkRole('PENDING_VALIDTION', 'REJECTED', 'INSULATION');
        },
        popUp: true,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.SUBMIT_INSULATION_DETAIL,
          method: 'POST',
          transformRequest: (data: any) => {
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(data['listScaffoldDetail']);
            if (searchtype === 'scaffoldId') {
              data['ScaffoldDetail'] = data['listScaffoldDetail'];
              data['listScaffoldDetail'] = [];
            }
            const remarks = data.reason;
            const {
              section,
              discipline,
              area,
              startDate,
              endDate,
              isWorkDetailRequire,
              isScaffoldingRequire,
              siteVisitDate,
              listWorkDetail,
              listScaffoldDetail,
              workDescription,
              workDetailRemarks,
            } = data;
            return {
              id: data.id,
              serviceProviderId: data.serviceProviderId,
              qaqcSupervisorName: data.qaqcSupervisorName,
              QAQCSupervisorEmail: formContext.form?.getFieldValue('email'),
              remarks,
              section,
              discipline,
              area,
              startDate,
              endDate,
              isWorkDetailRequire,
              isScaffoldingRequire,
              siteVisitDate,
              listWorkDetail,
              listScaffoldDetail,
              workDescription,
              workDetailRemarks,
              ScaffoldDetail: data.ScaffoldDetail,

              // service: getServiceByURL(statusRequest.type),
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole(
            'PENDING_VALIDTION',
            'SUBMITTED',
            'INSULATION',
          );
        },
        popUp: true,
      },
      {
        id: 3,
        key: 'All',
        title: 'Submit',
        type: TYPE.SUBMIT,
        popUp: true,
        request: {
          name: 'Submit',
          url: APIS.EDIT_INSULATION_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const newData = { ...data };
            delete newData['reason'];
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              newData['ScaffoldDetail'] = newData['listScaffoldDetail'];
              newData['listScaffoldDetail'] = [];
            }
            return {
              ...newData,
              remarks: data.reason,
              service: getServiceByURL(statusRequest.type),
            };
          },
        },
        checkRole: () => {
          return auth?.checkRole('PENDING_VALIDTION', 'EDITED');
        },
      },
    ],
    PENDING_PROPOSAL: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Reject',
          url: APIS.INSULATION_REJECTED,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.id,
              remarks: data.reason,
            };
          },
        },
        title: 'Reject',
        remarksRequired: true,
        checkRole: () => {
          return auth?.checkRole('PENDING_PROPOSAL', 'REJECTED');
        },
        popUp: true,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Save',
          url: APIS.SAVE_INSULATION_PROPOSAL,
          method: 'POST',
          transformRequest: (data: any) => {
            const { totalQuotedCost, attachments } = data.proposalBillingDetail;
            return {
              totalQuotedCost,
              id: data.id,
              data: data.proposalBillingDetail.data,
              attachments,
              remarks: data.reason,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('PENDING_PROPOSAL', 'SUBMITTED');
        },
        popUp: true,
      },
      {
        id: 3,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.SUBMIT_INSULATION_PROPOSAL,
          method: 'POST',
          transformRequest: (data: any) => {
            const { totalQuotedCost, attachments } = data.proposalBillingDetail;
            return {
              totalQuotedCost,
              id: data.id,
              data: data.proposalBillingDetail.data,
              attachments,
              remarks: data.reason,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_PROPOSAL', 'SUBMITTED');
        },
        popUp: true,
      },
      {
        id: 4,
        key: 'All',
        title: 'Submit',
        type: TYPE.SUBMIT,
        popUp: true,
        request: {
          name: 'Submit',
          url: APIS.EDIT_INSULATION_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            const newData = { ...data };
            delete newData['reason'];
            const searchtype = formContext.form?.getFieldValue('searchType');
            console.log(searchtype);
            if (searchtype === 'scaffoldId') {
              newData['ScaffoldDetail'] = newData['listScaffoldDetail'];
              newData['listScaffoldDetail'] = [];
            }
            return {
              ...newData,
              remarks: data.reason,
              service: getServiceByURL(statusRequest.type),
            };
          },
        },
        checkRole: () => {
          return auth?.checkRole('PENDING_PROPOSAL', 'EDITED');
        },
      },
    ],
    PENDING_REMOVAL: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Save',
          url: APIS.REMOVAL_COMPLETION_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationRemovalDetail, id } = data;
            return {
              id,
              ...insulationRemovalDetail,
              isSubmit: false,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return checkRoleOfConstractor(
            auth?.checkRole?.('PENDING_REMOVAL', 'SUBMITTED'),
          );
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: ' Submit',
          url: APIS.REMOVAL_COMPLETION_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationRemovalDetail, id, reason } = data;
            const dataChecklist: any = {};
            forEach(reason, (value: any, key: any) => {
              if (value !== '') {
                dataChecklist[key] = value;
              }
            });
            return {
              ...dataChecklist,
              ...insulationRemovalDetail,
              id,
              isSubmit: true,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return checkRoleOfConstractor(
            auth?.checkRole?.('PENDING_REMOVAL', 'SUBMITTED'),
          );
        },
        popUp: true,
      },
      {
        id: 4,
        key: 'CancelPTW',
        request: {
          name: 'Cancel',
          url: APIS.PTW_CANCEL_PROPOSAL,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.requestId,
              remarks: data.reason,
            };
          },
        },
        title: 'Cancel',
        checkRole: () => {
          return checkRoleOfInsua(
            auth?.checkRole('PENDING_REMOVAL', 'CANCELLED', 'INSULATION'),
          );
        },
        remarksRequired: true,
        popUp: true,
      },
      {
        id: 3,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.SUBMIT_REMOVAL_PTW,
          method: 'POST',
          transformRequest: (data: any) => {
            const ePTWno = map(data.listPTWDetail, (item: any) => item?.ePTWId);
            return {
              ePTWNo: ePTWno,
              id: data.id,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return checkRoleOfInsua(
            auth?.checkRole('PENDING_REMOVAL', 'EDITED', 'INSULATION'),
          );
        },
        popUp: false,
      },
    ],
    IN_SERVICE: [
      {
        id: 1,
        key: 'All',
        title: 'Submit',
        type: TYPE.SUBMIT,
        popUp: true,
        request: {
          name: 'Submit',
          url: APIS.EDIT_INSULATION_INSERVICE_REQUEST,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.id,
              startDate: data?.startDate,
              endDate: data?.endDate,
              listWorkDetail: data?.listWorkDetail,
              listScaffoldDetail: data?.listScaffoldDetail,
              isWorkDetailRequire: data?.isWorkDetailRequire,
              isScaffoldingRequire: data?.isScaffoldingRequire,
              remarks: data?.reason,
            };
          },
        },
        checkRole: () => {
          return auth?.checkRole('IN_SERVICE', 'EDITED');
        },
      },
    ],
    PENDING_REINSTATEMENT: [
      {
        id: 1,
        key: 'All',
        request: {
          name: ' Save',
          url: APIS.REINSTATEMENT_COMPLETION,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationReinstatementDetail, id } = data;
            // const isEdited = formContext.form?.getFieldValue('isEdited');
            // const billingData = data.proposalBillingDetail.data;
            // let BillingfilteredData: any = billingData;
            // let filterData: any = [];
            // console.log(billingData, 'billing data from submit');
            // if (isEdited) {
            //   BillingfilteredData = [];

            //   const idData = billingData.filter((item: any) =>
            //     item?.hasOwnProperty('id'),
            //   );
            //   const newData = billingData.filter((item: any) => item?.new);
            //   filterData = Object.values(
            //     billingData.reduce((acc: any, currVal: any) => {
            //       if (!(currVal?.WorklistID in acc)) {
            //         acc[currVal?.WorklistID] = currVal;
            //       } else {
            //         if (acc[currVal?.WorklistID]?.time < currVal?.time) {
            //           acc[currVal?.WorklistID] = currVal;
            //         }
            //       }
            //       return acc;
            //     }, {}),
            //   );
            //   BillingfilteredData = [...idData, ...filterData, ...newData];
            // }

            return {
              id,
              ...insulationReinstatementDetail,
              workItemDetail: data.proposalBillingDetail.data,
              poNumber: data.proposalBillingDetail.poNumber,
              totalQuotedCost: data.proposalBillingDetail.totalFinalCost,
              isSubmit: false,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return checkRoleOfConstractor(
            auth?.checkRole?.('PENDING_REINSTATEMENT', 'SUBMITTED'),
          );
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: ' Submit',
          url: APIS.REINSTATEMENT_COMPLETION,
          method: 'POST',
          transformRequest: (data: any) => {
            const { insulationReinstatementDetail, id } = data;
            // const isEdited = formContext.form?.getFieldValue('isEdited');
            // const billingData = data.proposalBillingDetail.data;
            // let BillingfilteredData: any = billingData;
            // let filterData: any = [];
            // console.log(billingData, 'billing data from submit');
            // if (isEdited) {
            //   BillingfilteredData = [];

            //   const idData = billingData.filter((item: any) =>
            //     item?.hasOwnProperty('id'),
            //   );
            //   const newData = billingData.filter((item: any) => item?.new);
            //   filterData = Object.values(
            //     billingData.reduce((acc: any, currVal: any) => {
            //       if (!(currVal?.WorklistID in acc)) {
            //         acc[currVal?.WorklistID] = currVal;
            //       } else {
            //         if (acc[currVal?.WorklistID]?.time < currVal?.time) {
            //           acc[currVal?.WorklistID] = currVal;
            //         }
            //       }
            //       return acc;
            //     }, {}),
            //   );
            //   BillingfilteredData = [...idData, ...filterData, ...newData];
            // }

            return {
              id,
              ...insulationReinstatementDetail,
              workItemDetail: data.proposalBillingDetail.data,
              poNumber: data.proposalBillingDetail.poNumber,
              totalQuotedCost: data.proposalBillingDetail.totalFinalCost,
              isSubmit: true,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return checkRoleOfConstractor(
            auth?.checkRole?.('PENDING_REINSTATEMENT', 'SUBMITTED'),
          );
        },
        popUp: false,
      },
      {
        id: 4,
        key: 'All',
        request: {
          name: 'Cancel',
          url: APIS.PTW_CANCEL_PROPOSAL,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.id,
              remarks: data.reason,
            };
          },
        },
        title: 'Cancel',
        checkRole: () => {
          return checkRoleOfInsua(
            auth?.checkRole('PENDING_REINSTATEMENT', 'CANCELLED', 'INSULATION'),
          );
        },
        remarksRequired: true,
        popUp: true,
      },
      {
        id: 3,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.SUBMIT_REINSTATEMENT_PTW,
          method: 'POST',
          transformRequest: (data: any) => {
            const ePTWNoRemoval = data?.ePTWNo?.ePTWNoRemoval || [];
            const ePTWNo = filter(
              data.listPTWDetail,
              item => !ePTWNoRemoval?.includes(item?.ePTWId),
            ).map(i => i?.ePTWId);
            return {
              ePTWNo: ePTWNo,
              id: data.id,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return checkRoleOfInsua(
            auth?.checkRole('PENDING_REINSTATEMENT', 'EDITED', 'INSULATION'),
          );
        },
        popUp: false,
      },
    ],
    PENDING_QAQC: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.REINSTATEMENT_CHECKLIST,
          method: 'POST',
          transformRequest: (data: any) => {
            const reinstatementData = data.reinstatementChecklist;

            return {
              ...reinstatementData,
              isSubmit: false,
              id: data.id,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('PENDING_QAQC', 'SAVED', 'INSULATION');
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.REINSTATEMENT_CHECKLIST,
          method: 'POST',
          transformRequest: (data: any) => {
            const reinstatementData = data.reinstatementChecklist;

            return {
              ...reinstatementData,
              isSubmit: true,
              id: data.id,
              remarks: data?.reason,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('PENDING_QAQC', 'SUBMITTED', 'INSULATION');
        },
        popUp: true,
      },
    ],
    BILLING: [
      {
        id: 1,
        key: 'All',
        request: {
          name: 'Save',
          url: APIS.BILLING_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            //to save data
            return {
              id: data.id,
              poNumber: data.proposalBillingDetail.poNumber,
              poNumber1: data.proposalBillingDetail.poNumber1,
              poNumber2: data.proposalBillingDetail.poNumber2,
              poNumber3: data.proposalBillingDetail.poNumber3,
              poCost: data.proposalBillingDetail.poCost,
              poCost1: data.proposalBillingDetail.poCost1,
              poCost2: data.proposalBillingDetail.poCost2,
              poCost3: data.proposalBillingDetail.poCost3,
              verifiedFinalCost: data.proposalBillingDetail.verifiedFinalCost,
              isSubmit: false,
            };
          },
        },
        title: 'Save',
        checkRole: () => {
          return auth?.checkRole('BILLING', 'SAVED', 'INSULATION');
        },
        popUp: false,
      },
      {
        id: 2,
        key: 'All',
        request: {
          name: 'Submit',
          url: APIS.BILLING_SUBMIT,
          method: 'POST',
          transformRequest: (data: any) => {
            return {
              id: data.id,
              poNumber: data.proposalBillingDetail.poNumber,
              poNumber1: data.proposalBillingDetail.poNumber1,
              poNumber2: data.proposalBillingDetail.poNumber2,
              poNumber3: data.proposalBillingDetail.poNumber3,
              poCost: data.proposalBillingDetail.poCost,
              poCost1: data.proposalBillingDetail.poCost1,
              poCost2: data.proposalBillingDetail.poCost2,
              poCost3: data.proposalBillingDetail.poCost3,
              verifiedFinalCost: data.proposalBillingDetail.verifiedFinalCost,
              isSubmit: true,
            };
          },
        },
        title: 'Submit',
        type: TYPE.SUBMIT,
        checkRole: () => {
          return auth?.checkRole('BILLING', 'SUBMITTED', 'INSULATION');
        },
        popUp: false,
      },
    ],
    CLOSED: [],
  };

  const handleEvent = (key: string) => {
    setShowPopup(key);
  };

  const handleConfirmEvent = (
    requestId?: string,
    actionProps?: any,
    reason?: any,
    key?: string,
  ) => {
    if (key === 'All') {
      const newData = convertMomentToString(actionProps?.getFormValues());
      const id = requestId;
      actionProps.submitData(
        correctData({
          ...newData,
          reason,
          id,
        }),
      );
    } else {
      const data = key && actionProps.field?.getFieldsValue()?.[key];
      actionProps.submitData(correctData({ requestId, data, reason }));
    }
    const listWorkDetail = actionProps?.getFormValues().listWorkDetail || [];
    const currentWorkDetail = listWorkDetail.length == 0 ? '' : 1;
    const currentArea = actionProps?.getFormValues().area || '';
    const currentStartDate = actionProps?.getFormValues().startDate || '';
    const currentEndDate = actionProps?.getFormValues().endDate || '';
    setShowPopup('');
  };

  const checkStatus = () => {
    const buttons = get(REQUEST_STATUS, statusRequest?.status, []);
    for (const item of buttons) {
      if (item?.checkRole && item?.checkRole()) {
        return true;
      }
    }
    return false;
  };

  const checkRoleOfConstractor = (checkRole: any) => {
    const ePTWNo = formContext.selectors?.getInitalValue()?.ePTWNo;
    if (statusRequest?.status === 'PENDING_REINSTATEMENT') {
      return checkRole && ePTWNo?.ePTWNoReinstatement?.length > 0;
    }
    return checkRole && ePTWNo?.ePTWNoRemoval?.length > 0;
  };
  const checkRoleOfInsua = (checkRole: any) => {
    const ePTWNo = formContext.selectors?.getInitalValue()?.ePTWNo;
    if (statusRequest?.status === 'PENDING_REINSTATEMENT') {
      return checkRole && !(ePTWNo?.ePTWNoReinstatement?.length > 0);
    }
    return checkRole && !(ePTWNo?.ePTWNoRemoval?.length > 0);
  };

  const checkActionRequest = () => {
    if (statusRequest?.state === 'VIEW') {
      return checkStatus() ? (
        <Space size={10}>
          <Button
            size="middle"
            onClick={() => {
              navigate(
                `/insulation/edit/${statusRequest?.id}?type=${get(
                  REQUEST_TYPE,
                  statusRequest?.type || REQUEST_TYPE.INSTATEMENT,
                )}`,
              );
            }}
          >
            Edit
          </Button>
        </Space>
      ) : null;
    }
    return (
      <Space size={10}>
        {get(REQUEST_STATUS, statusRequest?.status, []).map((item: any) => {
          if (item?.checkRole && !item?.checkRole()) return null;
          if (item && item?.request) {
            return (
              <ActionField
                key={item?.id}
                name={item?.request?.name}
                request={item?.request as Request}
                onResponseData={(dataRes: any) => {
                  if (dataRes?.code === 2) {
                    notification['error']({
                      message: `Submit ${
                        MAP_REQUEST_NAME[statusRequest?.status] || 'Error'
                      }`,
                      description: dataRes?.message,
                    });
                  } else if (dataRes?.code === 1) {
                    handleSubmitSuccess(dataRes);
                  }
                }}
              >
                {(actionProps: ActionFieldChildProps) => {
                  const missingInfoFormList = validateData(
                    actionProps,
                    listPanels,
                    statusRequest?.status,
                    { checkRole: auth.checkRole },
                  );
                  const requestId = formContext.form?.getFieldValue('id');

                  const validateInputData = () => {
                    const errors = [];
                    const isWd =
                      actionProps?.getFormValues().isWorkDetailRequire;
                    const listWorkDetail =
                      actionProps?.getFormValues().listWorkDetail || [];
                    const currentWorkDetail =
                      listWorkDetail.length == 0 ? '' : 1;
                    const currentArea = actionProps?.getFormValues().area;
                    const currentStartDate =
                      actionProps?.getFormValues().startDate || '';
                    const currentEndDate =
                      actionProps?.getFormValues().endDate || '';
                    const workRemarks =
                      actionProps?.getFormValues().workDetailRemarks;
                    if (statusRequest?.status === 'PENDING_VALIDTION') {
                      if (currentWorkDetail === '' && isWd === true) {
                        errors.push('-Work Detail');
                      }

                      if (currentArea == null) {
                        errors.push('-Area (Insulation Detail)');
                      }

                      if (currentStartDate === '') {
                        errors.push('-Start Date (Insulation Detail)');
                      }

                      if (currentEndDate === '') {
                        errors.push('-End Date (Insulation Detail)');
                      }

                      if (
                        (workRemarks === null || workRemarks.length < 20) &&
                        isWd === false
                      ) {
                        errors.push('-Reason should be more than 20 words');
                      }
                    }

                    if (statusRequest?.status === 'DRAFT') {
                      if (currentWorkDetail === '' && isWd === true) {
                        errors.push('-Work Detail');
                      }

                      if (currentArea == null) {
                        errors.push('-Area (Insulation Detail)');
                      }

                      if (currentStartDate === '') {
                        errors.push('-Start Date (Insulation Detail)');
                      }

                      if (currentEndDate === '') {
                        errors.push('-End Date (Insulation Detail)');
                      }

                      if (
                        (workRemarks === undefined ||
                          workRemarks.length < 20) &&
                        isWd === false
                      ) {
                        errors.push('-Reason should be more than 20 words');
                      }
                    }

                    if (statusRequest?.status === 'BILLING') {
                      const verifiedFinalCost =
                        actionProps.field?.getFieldsValue()
                          .proposalBillingDetail.verifiedFinalCost;
                      if (verifiedFinalCost == null) {
                        errors.push('Verified Final Cost');
                      }
                    }
                    return errors;
                  };

                  return (
                    <>
                      <Button
                        size="middle"
                        type={
                          item?.type === TYPE.SUBMIT ? 'primary' : 'default'
                        }
                        onClick={() => {
                          const errors = validateInputData();

                          if (errors.length > 0) {
                            const errorMessages = errors.join(', ');
                            alert(
                              `Please fill in: \n${errorMessages.replace(
                                /, /g,
                                '\n',
                              )}`,
                            );
                          } else {
                            if (item?.onClick) {
                              item?.onClick(actionProps);
                            } else if (!item?.popUp) {
                              handleConfirmEvent(
                                requestId,
                                actionProps,
                                '',
                                item?.key,
                              );
                            } else {
                              handleEvent(item?.request?.name);
                            }
                            onResetMessageNotice({
                              code: 0,
                              message: '',
                              data: 0,
                            });
                          }
                        }}
                      >
                        {item?.title}
                      </Button>

                      {item?.popUp ? (
                        <>
                          {statusRequest?.status === 'PENDING_REMOVAL' &&
                            item?.key !== 'CancelPTW' && (
                              <RemovalChecklist
                                visible={showPopup === item?.request?.name}
                                handleCancel={handleCancelSubmit}
                                handleSubmit={(checkListData: any) =>
                                  handleConfirmEvent(
                                    requestId,
                                    actionProps,
                                    checkListData,
                                    item?.key,
                                  )
                                }
                              />
                            )}
                          {(statusRequest?.status !== 'PENDING_REMOVAL' ||
                            item?.key === 'CancelPTW') && (
                            <Popup
                              title={`${item?.title} Confirmation`}
                              isVisible={showPopup == item?.request?.name}
                              handleOk={(remarks: string) => {
                                handleConfirmEvent(
                                  requestId,
                                  actionProps,
                                  remarks,
                                  item?.key,
                                );
                              }}
                              handleCancel={handleCancelSubmit}
                              description={`Are you sure you want to ${item?.title} request`}
                              tittleContent={
                                actionProps?.getFormValues()
                                  .lastSubmittedStatus === 7
                                  ? 'Remarks'
                                  : 'Remarks (Optional)'
                              }
                              requireContent={
                                actionProps?.getFormValues()
                                  .lastSubmittedStatus === 7
                                  ? true
                                  : false
                              }
                              status={statusRequest?.status}
                              lastSubmittedStatus={
                                actionProps?.getFormValues().lastSubmittedStatus
                              }
                            />
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                }}
              </ActionField>
            );
          } else {
            return null;
          }
        })}
      </Space>
    );
  };

  return (
    <div className="group-button">{statusRequest && checkActionRequest()}</div>
  );
};

export default SubmitComp;
